import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import { selectIsModalFeedbackThanksEnabled, selectModalFeedbackThanksData } from '../../../redux/main/main.selectors';
import { toggleModalFeedbackThanks } from '../../../redux/main/main.actions';

import Modal from '../Modal/Modal';
import './ModalFeedbackThanks.scss';


export const ModalFeedbackThanks = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    const isOpen = useSelector(selectIsModalFeedbackThanksEnabled);
    const modalData = useSelector(selectModalFeedbackThanksData);

    const [contentType, setContentType] = useState('');

    useEffect(() => {
        if (!modalData?.type) return;

        setContentType(modalData?.type || 'feedback');

        return () => { };
    }, [modalData]);

    const handleSave = () => {
        dispatch(toggleModalFeedbackThanks(null));
        setTimeout(() => {
            setContentType('');
        }, 300);
    };

    const handleCancel = () => {
        dispatch(toggleModalFeedbackThanks(null));
        setTimeout(() => {
            setContentType('');
        }, 300);
    };

    if (!contentType) return null;

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-feedback-thanks ${contentType}`}
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{`${t(`m_feedback_t.${contentType}.name`)} ❤️`}</div>
            <div className="modal-content-body">
                <div className='description-text'>
                    {t(`m_feedback_t.${contentType}.desc`)}
                </div>
                <button onClick={() => handleSave()}>{t('b.done')}</button>
            </div>
        </Modal>
    );
};

export default ModalFeedbackThanks;
